import { isIOS } from '@/js/auth/helpers/deviceUtils';

export const METAMASK_DAPP_AUTH_URL = isIOS() ? 'dapp://' : 'https://metamask.app.link/dapp/';
export const COINBASE_DAPP_AUTH_URL = 'https://www.coinbase.com/connect-dapp?uri=';
